module.exports = __webpack_public_path__ + "static/media/expert_notification_icon.0555a27c.svg";